import { ClientConfig } from '../types/profile';

export const mgrConfig: ClientConfig = {
  id: 'client-mgr-001',
  slug: 'mgr',
  profileUrl: (import.meta as any)?.env?.VITE_PROFILE_URL || 'https://profile.mgrmix.com',
  defaultLocale: 'ar',
  supportedLocales: ['ar', 'en'],
  identity: {
    name: {
      ar: 'الصخور الذهبية الحديثة ش.م.م',
      en: 'Modern Golden Rocks L.L.C',
    },
    tagline: {
      ar: 'أول مصنع متخصص في سلطنة عمان لتوريد وصناعة مواد لياسة كسر الرخام',
      en: 'First Specialized Factory in Oman for Marble-Chip Plaster Materials & Solutions',
    },
    description: {
      ar: 'أول مصنع متخصص في سلطنة عمان لتوريد وصناعة مواد لياسة كسر الرخام، معجون الخلطة الأسمنتية، أحجار كسر الرخام، كسر الزجاج، ومعدات وتقنيات كسر الرخام منذ عام 1995م.',
      en: 'The first specialized factory in Oman to supply and manufacture marble-chip plaster materials, cement mixture paste, marble chips, crushed glass, and technical tools since 1995.',
    },
    logoUrl: '/assets/modern-golden-rocks-full.png',
    avatarUrl: '/assets/modern-golden-rocks-symbol.png',
    badge: {
      ar: 'س.ت: 1410174',
      en: 'C.R.: 1410174',
    },
    verified: true,
  },
  branding: {
    primaryColor: '#04903c',
    primaryGlowColor: '#22c55e',
    accentGoldColor: '#0238a2',
    accentGreenColor: '#04903c',
    accentPurpleColor: '#0238a2',
    backgroundColor: '#0a1410',
    cardBackgroundColor: 'rgba(10, 26, 20, 0.85)',
    borderColor: 'rgba(4, 144, 60, 0.3)',
    textColor: '#f8fafc',
    mutedTextColor: '#94a3b8',
    borderRadius: '24px',
    logoStyle: 'glow',
    logoMotion: 'float',
    poweredByUrl: 'https://profile.jetown.net/smart-profile',
  },
  metadata: {
    title: {
      ar: 'الصخور الذهبية الحديثة | الملف الرقمي الذكي',
      en: 'Modern Golden Rocks | Smart Digital Profile',
    },
    description: {
      ar: 'الصخور الذهبية الحديثة — متخصصون في مواد لياسة كسر الرخام، الخلطات الإسمنتية، الحجر، الزجاج ومستلزمات واجهات كسر الرخام في سلطنة عمان.',
      en: 'Modern Golden Rocks — specialized in marble-chip plaster materials, cement mixtures, stone, glass and marble-chip facade solutions in the Sultanate of Oman.',
    },
    favicon: '/assets/mgr-favicon-32x32.png',
    appleTouchIcon: '/assets/mgr-apple-touch-icon.png',
    canonicalUrl: 'https://profile.mgrmix.com',
    ogTitle: {
      ar: 'الصخور الذهبية الحديثة | الملف الرقمي الذكي',
      en: 'Modern Golden Rocks | Smart Digital Profile',
    },
    ogDescription: {
      ar: 'الصخور الذهبية الحديثة — متخصصون في مواد لياسة كسر الرخام، الخلطات الإسمنتية، الحجر، الزجاج ومستلزمات واجهات كسر الرخام في سلطنة عمان.',
      en: 'Modern Golden Rocks — specialized in marble-chip plaster materials, cement mixtures, stone, glass and marble-chip facade solutions in the Sultanate of Oman.',
    },
    ogImage: '/assets/modern-golden-rocks-full.png',
    ogType: 'profile',
    siteName: {
      ar: 'شركة الصخور الذهبية الحديثة ش.م.م',
      en: 'Modern Golden Rocks L.L.C',
    },
    themeColor: '#04903c',
  },
  about: {
    title: {
      ar: 'من نحن',
      en: 'Who We Are',
    },
    paragraphs: [
      {
        ar: 'الصخور الذهبية أول مصنع متخصص في سلطنة عمان لتوريد وصناعة مواد لياسة كسر الرخام، ومنها معجون الخلطة الأسمنتية، وأحجار كسر الرخام، وكسر الزجاج، ومعدات وأدوات تقنية كسر الرخام.',
        en: 'Golden Rocks is the first specialized factory in the Sultanate of Oman to supply and manufacture marble-chip plaster materials, including cement mixture paste, marble chips, crushed glass, and technical equipment and tools for marble-chip applications.',
      },
      {
        ar: 'ونعتبر امتدادًا لمجموعة مصانع مؤسسة عبدالرحمن العمودي المنتشرة في المملكة العربية السعودية والمتخصصة في صناعة المواد والخلطات الإسمنتية، ومنها مواد كسر الرخام منذ عام 1995م.',
        en: "We are an extension of the Abdulrahman Al-Amoudi Corporation's group of factories in the Kingdom of Saudi Arabia, specialized in cement materials and mixtures, including marble-chip materials, since 1995.",
      },
      {
        ar: 'نستخدم أفضل وأجود المواد الأولية والكيماوية الأوروبية في صناعة خلطة كسر الرخام. هدفنا ضمان الجودة ورضا عملائنا وتسهيل العمل للمتخصصين في هذا المجال.',
        en: 'We use high-quality European raw and chemical materials in the manufacture of the marble-chip mixture. Our goal is to ensure quality and customer satisfaction and facilitate the work of specialists in this field.',
      },
    ],
  },
  servicesTitle: {
    ar: 'حلول متكاملة لواجهات كسر الرخام',
    en: 'Integrated Marble-Chip Facade Solutions',
  },
  services: [
    {
      id: 'mgr-mix',
      title: {
        ar: 'معجون خلطة كسر الرخام (MGR MIX)',
        en: 'MGR MIX Cement Mixture Paste',
      },
      description: {
        ar: 'معجون الخلطة الأسمنتية المطور بالمواد الكيماوية الأوروبية لضمان أعلى قوة التصاق ومقاومة للعوامل الجوية والرطوبة.',
        en: 'High-performance cement mixture paste enriched with European chemicals for superior bonding and climatic endurance.',
      },
      badge: { ar: 'المنتج الأساسي', en: 'Flagship Paste' },
      highlighted: true,
    },
    {
      id: 'glue-mixtures',
      title: {
        ar: 'خلطات الجلو واللواصق (Glue)',
        en: 'Specialized Glue & Bonding Agents',
      },
      description: {
        ar: 'مركبات جلو ولاصق عالية القوة مخصصة لتثبيت كسر الرخام والواجهات الخارجية بأعلى درجات الأمان الإنشائي.',
        en: 'High-strength adhesive and glue mixtures engineered for secure exterior marble-chip facade anchoring.',
      },
      badge: { ar: 'التصاق فائق', en: 'High Bond' },
    },
    {
      id: 'spanish-stone',
      title: {
        ar: 'أحجار كسر الرخام الإسباني (Spanish Stone)',
        en: 'Spanish Marble Stone Chips',
      },
      description: {
        ar: 'أحجار كسر رخام طبيعي مستوردة من إسبانيا بتدرجات لونية راقية ونقاء حبيبي استثنائي لواجهات معمارية فاخرة.',
        en: 'Natural Spanish marble chips offering exquisite hues and superior texture for luxury architectural facades.',
      },
      badge: { ar: 'مستورد', en: 'Imported' },
    },
    {
      id: 'indian-stone',
      title: {
        ar: 'أحجار كسر الرخام الهندي (Indian Stone)',
        en: 'Indian Marble Stone Chips',
      },
      description: {
        ar: 'أحجار كسر رخام هندية صلبة بألوان طبيعية متعددة ومقاومة عالية لأشعة الشمس والحرارة والظروف المناخية القاسية.',
        en: 'Resilient Indian marble chips with rich natural shades, highly resistant to UV rays and intense thermal exposure.',
      },
      badge: { ar: 'صلابة ومتانة', en: 'High Strength' },
    },
    {
      id: 'omani-stone',
      title: {
        ar: 'أحجار كسر الرخام العماني (Omani Stone)',
        en: 'Omani Marble Stone Chips',
      },
      description: {
        ar: 'أحجار كسر رخام طبيعي مستخرجة من المحاجر العمانية الأصيلة بجودة ممتازة ومتوافقة تماماً مع الطبيعة البيئية للمنطقة.',
        en: 'Authentic natural Omani marble chips from historic quarries, providing premium durability attuned to local architecture.',
      },
      badge: { ar: 'إنتاج محلي', en: 'Local Heritage' },
    },
    {
      id: 'glass-chips',
      title: {
        ar: 'كسر الزجاج الفاخر (Crushed Glass)',
        en: 'Architectural Crushed Glass',
      },
      description: {
        ar: 'حبيبات كسر زجاج نقي معالج لإضفاء بريق وانعكاسات جمالية عصرية على تشطيبات واجهات كسر الرخام والتصميم الحديث.',
        en: 'Processed pure crushed glass granules adding luminous aesthetic reflections and modern elegance to facade finishes.',
      },
      badge: { ar: 'لمعان عصري', en: 'Aesthetic Glow' },
    },
    {
      id: 'pvc-splines',
      title: {
        ar: 'فواصل التمدد البلاستيكية (PVC Splines)',
        en: 'PVC Expansion Joint Splines',
      },
      description: {
        ar: 'فواصل بلاستيكية هندسية دقيقة لتنظيم تقسيمات الواجهات وامتصاص التمدد والتقلص وحماية طبقات اللياسة من التصدع.',
        en: 'Engineered PVC joint splines to structure facade segments, absorb thermal expansion, and protect against cracking.',
      },
      badge: { ar: 'حماية وتشكيل', en: 'Joint Control' },
    },
    {
      id: 'plastic-corners',
      title: {
        ar: 'الزوايا البلاستيكية الهندسية (Plastic Corners)',
        en: 'Plastic Corner Beads & Trims',
      },
      description: {
        ar: 'زوايا بلاستيكية متينة لتسوية وضبط استقامة حواف الأركان والفتحات المعمارية وحمايتها من الاصطدامات والكسر.',
        en: 'Durable plastic corner beads ensuring razor-straight architectural edges and lasting edge impact defense.',
      },
      badge: { ar: 'استقامة الحواف', en: 'Edge Defense' },
    },
  ],
  contacts: {
    phone: '+96822391555',
    whatsapp: '+96899032600',
    whatsappGreeting: {
      ar: 'مرحباً شركة الصخور الذهبية الحديثة، أود الاستفسار عن مواد وخلطات كسر الرخام',
      en: 'Hello Modern Golden Rocks LLC, I would like to inquire about marble-chip plaster materials',
    },
    email: 'info@mgrmix.com',
    website: 'https://mgrmix.com',
    mapUrl: 'https://maps.app.goo.gl/uBPb9ya5cUrv9UyR8',
    address: {
      ar: 'المسفاة، بوشر، محافظة مسقط، سلطنة عمان',
      en: 'Al Misfah, Bousher, Muscat Governorate, Sultanate of Oman',
    },
  },
  socials: [
    {
      id: 'office-tel',
      platform: 'office-phone',
      url: 'tel:+96822391555',
      label: {
        ar: 'هاتف المكتب (+968 22391555)',
        en: 'Office Tel (+968 22391555)',
      },
    },
    {
      id: 'official-web',
      platform: 'website',
      url: 'https://mgrmix.com',
      label: {
        ar: 'الموقع الرسمي (mgrmix.com)',
        en: 'Official Website (mgrmix.com)',
      },
    },
    {
      id: 'whatsapp-sales',
      platform: 'whatsapp',
      url: 'https://wa.me/96899032600',
      label: {
        ar: 'واتساب (+968 99032600)',
        en: 'WhatsApp (+968 99032600)',
      },
    },
    {
      id: 'email-direct',
      platform: 'email',
      url: 'mailto:info@mgrmix.com',
      label: {
        ar: 'البريد الرسمي (info@mgrmix.com)',
        en: 'Official Email (info@mgrmix.com)',
      },
    },
    {
      id: 'location-map',
      platform: 'maps',
      url: 'https://maps.app.goo.gl/uBPb9ya5cUrv9UyR8',
      label: {
        ar: 'موقع المصنع على خرائط Google',
        en: 'Google Maps Location',
      },
    },
    {
      id: 'instagram-mgr',
      platform: 'instagram',
      url: 'https://www.instagram.com/moderngoldenrocks',
      label: {
        ar: 'إنستغرام',
        en: 'Instagram',
      },
    },
  ],
  virtualTour: {
    enabled: true,
    url: 'https://jet-malls.com/globe/mgrmix',
    label: {
      ar: 'جولة الواقع الافتراضي 360°',
      en: '360° Virtual Tour Experience',
    },
    description: {
      ar: 'استكشف منتجات ومعارض الصخور الذهبية الحديثة بتجربة تفاعلية ثلاثية الأبعاد 360° عبر منصة Jet-Malls.',
      en: 'Explore Modern Golden Rocks products and showrooms in 360° interactive virtual reality on Jet-Malls.',
    },
    badge: {
      ar: 'VR 360°',
      en: 'VR 360°',
    },
    promotionEnabled: true,
    promotionUrl: 'https://jet-malls.com/backend/register',
    promotionLabel: {
      ar: 'منظومة المعارض الافتراضية Jet-Malls (تسجيل)',
      en: 'Jet-Malls Virtual Exhibition Platform (Register)',
    },
  },
  features: {
    vCardDownload: true,
    qrModal: true,
    shareProfile: true,
    contactForm: true,
    aiAssistant: false,
    servicesShowcase: true,
    socialGrid: true,
    virtualTour: true,
  },
  qr: {
    enabled: true,
    branded: true,
    logo: true,
    foreground: '#04903c',
    background: '#ffffff',
    accent: '#0238a2',
  },
  footerText: {
    ar: '© 2026 شركة الصخور الذهبية الحديثة ش.م.م. جميع الحقوق محفوظة.',
    en: '© 2026 Modern Golden Rocks L.L.C. All rights reserved.',
  },
  regionsText: {
    ar: 'مسقط • بوشر • المسفاة • سلطنة عمان',
    en: 'Muscat • Bousher • Al Misfah • Sultanate of Oman',
  },
};
